export const GET_assets = ({ assets }, getters, rootState) => {
  if (typeof assets != 'undefined') {
    let assets_list = []
    let acquisitions_list = rootState.acquisitions.acquisitions
    for (let index = 0; index < assets.length; index++) {
      assets_list[index] = { ...assets[index] }
      acquisitions_list.map((acquisition) => {
        if (acquisition.id == assets[index].acquisition_id) {
          assets_list[index].asset_number = assets_list[index].asset_number.toString()
          assets_list[index].owner_entity_id = acquisition.owner_entity_id
          assets_list[index].owner_entity = acquisition.owner_entity
          assets_list[index].description = acquisition.description
        }
      })
    }
    return assets_list.filter((asset) => {
      return asset.owner_entity_id === 1
    })
  }
}

export const GET_assetsWithoutTranfered = ({ assets }, getters, rootState) => {
  if (typeof assets != 'undefined') {
    let assets_list = []
    let acquisitions_list = rootState.acquisitions.acquisitions
    for (let index = 0; index < assets.length; index++) {
      assets_list[index] = { ...assets[index] }
      acquisitions_list.map((acquisition) => {
        if (
          acquisition.id == assets[index].acquisition_id &&
          acquisition.acquisition_status_id != 4
        ) {
          assets_list[index].asset_number = assets_list[index].asset_number.toString()
          assets_list[index].owner_entity_id = acquisition.owner_entity_id
          assets_list[index].owner_entity = acquisition.owner_entity
          assets_list[index].description = acquisition.description
          assets_list[index].selected = false
        }
      })
    }
    return assets_list.filter((asset) => {
      return asset.owner_entity_id === 1
    })
  }
}
